import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  getTextPadding,
  getScaledFont,
} from '@wix/editor-elements-common-utils';
import type { ComboBoxInputDefinition } from '../../ComboBoxInput/ComboBoxInput.types';
import type { IComboBoxInputListModalCSSVars } from '../ComboBoxInputListModal.types';

const justifyContent = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
} as const;

export const css = withCompInfo<
  IComboBoxInputListModalCSSVars,
  ComboBoxInputDefinition,
  {}
>()(
  [
    'compProps',
    'styleProperties',
    'compLayout',
    'hasResponsiveLayout',
    'isMobileView',
    'siteFonts',
  ],
  ({
    compProps,
    styleProperties,
    compLayout,
    hasResponsiveLayout,
    isMobileView,
    siteFonts,
  }) => {
    const compInfo = { compLayout, styleProperties, siteFonts, isMobileView };
    const { textAlignment, dropdownItemsSpacing, inputMobileFontSize } =
      compProps;
    const dropdownOptionJustifyContent =
      justifyContent[textAlignment!] || 'flex-start';

    return {
      height: '100%',
      '--fnt': getScaledFont(compInfo, 'fnt', inputMobileFontSize),
      '--dropdownItemsSpacing': `${
        typeof dropdownItemsSpacing === 'number' ? dropdownItemsSpacing : 16
      }px`,
      '--dropdownOptionJustifyContent': dropdownOptionJustifyContent,
      '--dir': textAlignment === 'right' ? 'rtl' : 'ltr',
      '--textAlign': textAlignment!,
      '--textPadding': getTextPadding(compProps),
      ...(!hasResponsiveLayout && { width: 'initial' }),
    };
  },
);

export default createComponentMapperModel({ css });
